"use client";

// import { getAOSAnimation } from "@litonarefin/utils/getAOSAnimation";
import { sanitize } from "@litonarefin/utils/miscellaneous";

const Blockquote = ({ attributes }) => {
  // const allAOS = getAOSAnimation(attributes);

  return (
    <div
      {...(attributes?.anchor && { id: attributes?.anchor })}
      // {...allAOS}
      className="jlt-py-12 jlt-px-5 md:jlt-p-12 jlt-rounded-lg jlt-relative jlt-mx-auto"
      style={{
        boxShadow: "0px 0px 35px rgba(55, 68, 70, 0.1)",
        background: "linear-gradient( 255.96deg,rgba(250, 252, 255, 0) 0%, #ffffff 100% )",
        maxWidth: `${attributes?.width}px`,
      }}
    >
      <div
        className="jlt-absolute jlt-top-[-35px] jlt-right-[32px] md:jlt-top-[-50px] nd:jlt-right-[46px] jlt-w-[70px] jlt-h-[70px] md:jlt-w-24 md:jlt-h-24 jlt-rounded-full jlt-flex jlt-items-center jlt-justify-center"
        style={{
          background: "linear-gradient(97.69deg, #256eff 0%, #8957f1 99.34%)",
        }}
      >
        <svg
          width="43"
          height="37"
          viewBox="0 0 43 37"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M42.4365 8.9608L42.3833 8.55623L42.328 8.57068C41.95 6.56958 41.0794 4.73053 39.8167 3.26632C38.5541 1.80212 36.9511 0.772599 35.1932 0.296888C33.4354 -0.178824 31.5944 -0.0812847 29.8835 0.57822C28.1725 1.23772 26.6614 2.43224 25.5251 4.02355C24.3888 5.61486 23.6736 7.53793 23.4624 9.57025C23.2511 11.6026 23.5525 13.6611 24.3315 15.5076C25.1105 17.3541 26.3354 18.9131 27.8644 20.0043C29.3934 21.0955 31.164 21.6742 32.9714 21.6735C33.4457 21.6735 33.9009 21.5917 34.3539 21.517C34.2072 22.0757 34.0562 22.644 33.8137 23.1546C33.5712 23.8963 33.1926 24.5393 32.8161 25.1871C32.5013 25.8878 31.9462 26.3622 31.5378 26.9619C31.1103 27.5446 30.5275 27.9324 30.066 28.4164C29.6129 28.9221 29.0195 29.175 28.5473 29.5314C28.0538 29.8517 27.6242 30.2057 27.1647 30.3743L26.0183 30.9089L25.0101 31.3833L26.0396 36.0527L27.3094 35.7059C27.7156 35.5903 28.2112 35.4555 28.7749 35.2941C29.3513 35.1737 29.966 34.8438 30.6509 34.5428C31.3251 34.1984 32.11 33.9697 32.8374 33.4182C33.5691 32.8932 34.4135 32.4549 35.1579 31.7517C35.879 31.0269 36.7489 30.3983 37.3913 29.4784C38.0932 28.6163 38.7866 27.7108 39.3247 26.6801C39.9479 25.6976 40.3712 24.6187 40.8178 23.5519C41.222 22.4851 41.5474 21.3942 41.8133 20.3346C42.3173 18.2106 42.5428 16.1925 42.63 14.4659C42.7023 12.7368 42.6598 11.2991 42.5705 10.2588C42.5406 9.82435 42.4959 9.39135 42.4365 8.9608ZM19.0397 8.9608L18.9865 8.55623L18.9312 8.57068C18.5533 6.56958 17.6826 4.73053 16.42 3.26632C15.1573 1.80212 13.5544 0.772599 11.7965 0.296888C10.0386 -0.178824 8.19766 -0.0812847 6.48669 0.57822C4.77573 1.23772 3.26466 2.43224 2.12833 4.02355C0.991992 5.61486 0.276833 7.53793 0.0655984 9.57025C-0.145636 11.6026 0.155688 13.6611 0.934706 15.5076C1.71372 17.3541 2.93859 18.9131 4.46759 20.0043C5.99659 21.0955 7.76723 21.6742 9.57463 21.6735C10.0489 21.6735 10.5041 21.5917 10.9572 21.517C10.8104 22.0757 10.6594 22.644 10.4169 23.1546C10.1744 23.8963 9.79584 24.5393 9.41936 25.1871C9.10457 25.8878 8.54943 26.3622 8.14105 26.9619C7.71352 27.5446 7.13073 27.9324 6.66918 28.4164C6.21613 28.9221 5.6227 29.175 5.15051 29.5314C4.65706 29.8517 4.22741 30.2057 3.76798 30.3743L2.62154 30.9089C1.98132 31.2051 1.61547 31.3785 1.61547 31.3785L2.64493 36.0479L3.91474 35.7011C4.32099 35.5855 4.81658 35.4507 5.38023 35.2893C5.95664 35.1689 6.57134 34.839 7.25622 34.538C7.93048 34.1936 8.71533 33.9648 9.44276 33.4134C10.1744 32.8884 11.0188 32.4501 11.7633 31.7469C12.4843 31.0221 13.3543 30.3935 13.9966 29.4736C14.6985 28.6115 15.3919 27.706 15.93 26.6753C16.5532 25.6928 16.9765 24.6139 17.4232 23.5471C17.8273 22.4803 18.1527 21.3894 18.4186 20.3298C18.9227 18.2058 19.1482 16.1877 19.2354 14.4611C19.3077 12.732 19.2651 11.2943 19.1758 10.254C19.1441 9.82123 19.0987 9.38989 19.0397 8.9608Z"
            fill="white"
          />
        </svg>
      </div>
      <div className="jlt-flex jlt-justify-center jlt-w-20 jlt-h-20 jlt-rounded-full jlt-overflow-hidden jlt-m-auto">
        <img
          src={attributes?.authorImageURL}
          alt={attributes?.authorImageAlt}
          width={80}
          height={80}
        />
      </div>
      <h3
        className="jlt-mt-6 jlt-text-2xl jlt-text-[#16213E] jlt-font-bold jlt-leading-8 jlt-text-center"
        dangerouslySetInnerHTML={{
          __html: sanitize(attributes?.title || ""),
        }}
      />

      <p
        className="jlt-mt-6 jlt-text-lg jlt-text-[#3F475A] jlt-font-medium jlt-leading-[30px] jlt-text-center jlt-italic"
        dangerouslySetInnerHTML={{
          __html: sanitize(attributes?.description || ""),
        }}
      />

      <h3
        className="jlt-mt-6 jlt-text-lg jlt-text-[#16213E] jlt-font-bold jlt-leading-7 jlt-text-center"
        dangerouslySetInnerHTML={{
          __html: sanitize(attributes?.author || ""),
        }}
      />

      <p
        className="jlt-text-sm jlt-text-[#ADADBC] jlt-font-normal jlt-leading-5 jlt-text-center"
        dangerouslySetInnerHTML={{
          __html: sanitize(attributes?.authorSite || ""),
        }}
      />
    </div>
  );
};

export default Blockquote;
